import { AutogenLayoutRenditionRuleProfiles } from "./autogen/AutogenLayoutRenditionRuleProfiles";
import {  ClickEvent,  DropdownSelectionEvent } from "@mcleod/components";

export class RenditionRuleProfiles extends AutogenLayoutRenditionRuleProfiles {

  private timer: any;

  override onLoad() {
    //console.log(this);
    clearInterval(this.timer);
    this.timer = setInterval(() => this.SearchImapCats(), 100);
  }

  SearchImapCats() {
    //console.log(this);
    clearInterval(this.timer);
    this.timer = null;
    this.sourceImapCats.search();
  }

/** This is an event handler for the onDblClick event of . */
  OnDblClick(event: ClickEvent) {
    const catid = this.table1.selectedRow.data.get("icat_catid");
    this.tbRulepExpression.text += "$" + catid;
    const row: any = this.tbRulepExpression.dataSource.activeRow;
    row.set( "rulep_expression", this.tbRulepExpression.text );
  }

/** This is an event handler for the onDropdownSelection event of textboxOperatos. */
  textboxOperatosAfterDropdownSelection(event: DropdownSelectionEvent) {
    const val = event.selection.displayValue.charAt(0);
    this.tbRulepExpression.text += val;
    const row: any = this.tbRulepExpression.dataSource.activeRow;
    row.set( "rulep_expression", this.tbRulepExpression.text );
    this.textboxOperatos.text = "";
  }
}
